import {
  FormikAutocompleteField,
  FormikSelectField,
  FormikTextField,
} from '@cmg/design-system-formik';

import { FormFieldLayout } from '../../../../../../design-system/body-sections/form/FormFieldLayout';
import { FormLayout } from '../../../../../../design-system/body-sections/form/FormLayout';
import { USER_DETAIL_FIELD_LABELS } from '../models/UserDetailsSection.model';
import { UNDERWRITER_EMPLOYEE_JOB_FUNCTION_OPTIONS } from './EmployeeUserDetailsFields.model';

export type EmployeeUserDetailsFieldsProps = Readonly<{
  disableEmployeeKey?: boolean;
  autoFocusNameField?: boolean;
  autoFocusEmployeeKeyField?: boolean;
}>;

const EMPTY_OPTIONS = [];

export function EmployeeUserDetailsFields({
  disableEmployeeKey = false,
  autoFocusNameField = false,
  autoFocusEmployeeKeyField = false,
}: EmployeeUserDetailsFieldsProps) {
  return (
    <FormLayout>
      <FormFieldLayout>
        <FormikTextField
          name="employeeKey"
          label={USER_DETAIL_FIELD_LABELS.employeeKey}
          required
          fullWidth
          disabled={disableEmployeeKey}
          autoFocus={autoFocusEmployeeKeyField}
        />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField
          name="name"
          label={USER_DETAIL_FIELD_LABELS.name}
          fullWidth
          autoFocus={autoFocusNameField}
        />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikAutocompleteField
          name="titles"
          label={USER_DETAIL_FIELD_LABELS.titles}
          options={EMPTY_OPTIONS}
          multiple
          freeSolo
        />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikSelectField
          name="jobFunction"
          label={USER_DETAIL_FIELD_LABELS.jobFunction}
          options={UNDERWRITER_EMPLOYEE_JOB_FUNCTION_OPTIONS}
          fullWidth
        />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="department" label={USER_DETAIL_FIELD_LABELS.department} fullWidth />
      </FormFieldLayout>
    </FormLayout>
  );
}
